import colors from '../global/color';
import BaseTheme from './BaseTheme';


const B2BTheme = {
  ...BaseTheme,
  color: {
    button: {
      primary: colors.brand_60,
      primary_hover: colors.brand_70,
      primary_pressed: colors.brand_80,
      primary_text: colors.gray_05,
      primary_outline: colors.brand_40,
      primary_outline_text: colors.brand_40,
      primary_outline_hover: colors.brand_80,
      primary_outline_pressed: colors.brand_70,
      secondary: colors.gray_20,
      secondary_hover: colors.gray_70,
      secondary_pressed: colors.gray_80,
      secondary_text: colors.gray_05,
      secondary_outline: colors.gray_60,
      secondary_outline_text: colors.gray_40,
      secondary_outline_hover: colors.gray_95,
      secondary_outline_pressed_: colors.gray_90,
      tertiary: colors.gray_20,
      tertiary_hover: colors.gray_30,
      tertiary_pressed: colors.gray_40,
    },
    input: {
      background_: colors.gray_100,
      background_hover: colors.gray_95,
      background_active: colors.gray_100,
      background_error: colors.red_90,
      line: colors.gray_70,
      line_hover: colors.gray_60,
      line_active: colors.brand_40,
      line_error: colors.red_60,
    },
    radio: {
      normal: colors.gray_60,
      hover_stroke: colors.brand_40,
      hover_fill: colors.brand_80,
      active_fill: colors.brand_70,
      disable_stroke: colors.gray_70,
      disable_filled: colors.gray_90,
      text: colors.gray_05,
    },
    stroke: {
      light: colors.gray_80,
      medium: colors.gray_70,
      tooltip: colors.gray_80,
    },
    separator: {
      primary: colors.gray_60,
      secondary: colors.gray_70,
      tertiary: colors.gray_80,
    },
    alert: {
      background_warning: colors.yellow_80,
      background_error: colors.red_80,
      background_success: colors.green_80,
      background_violet: colors.brand_70,
      text_warning: colors.yellow_40,
      text_error: colors.red_40,
      text_success: colors.green_40,
      text_violet: colors.brand_20,
    },
    text: {
      primary: colors.gray_05,
      secondary: colors.gray_40,
      disabled: colors.gray_70,
      highlight: colors.gray_80,
      hyperlink: colors.brand_50,
      hyperlink_hover: colors.brand_40,
      hyperlink_focus: colors.brand_50,
      error: colors.red_40,
      underline : colors.blue_60
    },
    icon: {
      primary: colors.white,
      secondary: colors.gray_70,
      white: colors.white,
      brand: colors.brand_30,

    },
    background: {
      primary: colors.gray_100,
      secondary: colors.gray_95,
      tertiary: colors.gray_90,
      quaternary: colors.gray_80,
      brand: colors.brand_60,
      iconFill: colors.white,

    },
  },

};

export default B2BTheme;
